// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2R7Qi","fileDisabled":"File_fileDisabled__1DIGw"};